import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import classnames from 'classnames';
import { sizes, colors, directions } from "../../../enums";
import { toUIProps } from "../../../util";
import { whitelistStyles } from "../hoc";
import { Button as UIButton } from 'semantic-ui-react';
import Button from "../button";
var propMap = {
  isFluid: 'fluid',
  "float": 'floated'
};
var UNSUPPORTED_PROPS = ['attached', 'as', 'className', 'basic', 'floated', 'icon', 'labeled', 'vertical', 'widths'];
var ADDED_PROPS = ['spacing', 'isFluid', 'isInverted', 'layout'];
var MODIFIED_PROPS = ['color', 'onClick', 'children'];

var isButton = function isButton(component) {
  return Utils.isType(Button.Primary, component) || Utils.isType(Button.Secondary, component) || Utils.isType(Button.WithAnimation, component);
};
/**
 * Adds properties to buttons within a React component tree.

 * @param {_props} props - The properties to add to buttons.
 * @param {React.ReactNode} children - The React children to process.
 * @param {string[]} childPropWhitelist - The whitelisted properties that can be added to buttons.
 * @param {number} depth - The current depth in the component tree. Defaults to 0.

 * @returns {React.ReactNode} The modified React children with added properties.

 * This function iterates through the React children and checks if each child is a button.
 * If it is, it adds the specified properties to the button's props, ensuring that the depth doesn't exceed 2.
 * If the child has children, the function recursively calls itself to process those children.
 */


function addPropToButtons(_props, children, childPropWhitelist, depth) {
  if (depth === void 0) {
    depth = 0;
  }

  var _children = React.Children.toArray(children);

  return _mapInstanceProperty(_).call(_, _children, function (child) {
    if (isButton(child)) {
      if (depth >= 2) {
        return /*#__PURE__*/React.cloneElement(child, child.props); // Stop at depth 2
      }

      var defaultProps = _.pick(_props, childPropWhitelist);

      var childProps = _extends({}, defaultProps, child.props);

      return /*#__PURE__*/React.cloneElement(child, childProps);
    }

    if (child.props.children) {
      return /*#__PURE__*/React.cloneElement(child, {
        children: addPropToButtons(_props, child.props.children, childPropWhitelist, depth + 1)
      });
    }

    return /*#__PURE__*/React.cloneElement(child, child.props);
  });
}

var ButtonGroup = createComponent({
  displayName: 'ButtonGroup',
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
    // Buttons only
    color: PropTypes.oneOf(colors.CORE),
    isFluid: PropTypes.bool,
    layout: PropTypes.oneOf(directions.HORIZONTAL_VERTICAL),
    size: PropTypes.oneOf(sizes.ALL),
    spacing: PropTypes.oneOf(sizes.S_M_L),
    onClick: PropTypes.func
  },
  defaultProps: {
    color: colors.ACCENT,
    isFluid: false,
    layout: directions.HORIZONTAL,
    size: sizes.X3,
    spacing: undefined,
    onClick: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _classnames;

    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      MODIFIED_PROPS: MODIFIED_PROPS,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS
    });
    var children = addPropToButtons(props, props.children, ['onClick', 'color', 'size']);

    if (props.layout === directions.VERTICAL) {
      UIProps.vertical = true;
    }

    UIProps.className = classnames('ck', props.spacing, (_classnames = {}, _classnames[props.layout + "-spacing"] = !!props.spacing, _classnames), // needs to stay in this order
    {
      fluid: props.isFluid
    });
    return /*#__PURE__*/React.createElement(UIButton.Group, UIProps, children);
  }
});
export var PrivateButtonGroup = whitelistStyles()(ButtonGroup);
export default PrivateButtonGroup;
//# sourceMappingURL=button-group.js.map